
import { createSlice } from "@reduxjs/toolkit";

const initialState = { agent: null }

export const agentSlice = createSlice({
    name: "agent",
    initialState,
    reducers: {
        createAgent: (state, action) => {
            return { ... state,
                agent: {
                    id: action.payload.id,
                    nome: action.payload.nome,
                    plano: action.payload.plano,
                    status: action.payload.status,
                }
            }
        },
        updateAgent: (state, action) => {
            return { ... state,
                agent: {
                    id: action.payload.id,
                    nome: action.payload.nome,
                    plano: action.payload.plano,
                    status: action.payload.status,
                }
            }
        },
        deleteAgent: (state) => {
            return { ... state,
                agent: null,
            }
        }
    }
})

export const { createAgent, updateAgent, deleteAgent } = agentSlice.actions; 
export default agentSlice.reducer;